export function ensureFocus() {
	window.focus();
	
	if (!document.activeElement || document.activeElement === document.body) {
	    if (!document.body.hasAttribute('tabindex')) {
		document.body.setAttribute('tabindex', '0');
		document.body.style.outline = 'none';
	    }
	    document.body.focus();
	}		
}
